import DangerousModal from "./DangerousModal";

export default DangerousModal;
